import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { GridItemData } from 'Vendor/Utils/StudioTypes';

type Handle =
    | 'top-left'
    | 'top-center'
    | 'top-right'
    | 'middle-left'
    | 'middle-right'
    | 'bottom-left'
    | 'bottom-center'
    | 'bottom-right';

interface ResizeHandleProps {
    item: GridItemData;
    handle: Handle;
}

const _ResizeHandle: React.FC<ResizeHandleProps> = ({ item, handle }) => {
    const { attributes, listeners, setNodeRef } = useDraggable({
        id: `${item.id}-resize-${handle}`,
        data: {
            type: 'resize',
            item,
            handle,
        },
    });

    return (
        <div
            ref={setNodeRef}
            {...attributes}
            {...listeners}
            className={`resize-handle ${handle}`}
            onMouseDown={(e) => {
                e.stopPropagation();
                e.preventDefault();
            }}
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
            }}
        />
    );
};

export default _ResizeHandle;
